module.exports = __webpack_public_path__ + "media/images/help-c625feace3d7a4ca58b8d89d6f92aee8.svg";